<template>
  <div class="content">
    <div class="left">
      <img
        src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624eaa52c435e/601232643.png"
        alt=""
      />
    </div>
    <div class="right">
      <div class="headline">- 作答区域 -</div>
      <div class="submitList" v-show="submitList.length > 0">
        <span>已提交：</span>
        <div v-for="(item, index) of submitList" :key='index'>答案{{ index + 1 }}</div>
      </div>
      <div class="title">
        点击录音标志开始录音，确认显示文字无误后，点击对勾，并开始下一个内容录音；
      </div>
      <div class="desc">* 确认的文字不能修改，作答时间 2 分钟。</div>
      <div class="tip">自动翻译：</div>
      <div class="record">
        <div>{{ record }}</div>
        <div class="collect" @click="startRecord">
          <img
            src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624eaa56ce32f/594796574.png"
            alt=""
          />
          <span>点击录音</span>
        </div>
        <div class="submit" @click="submit">提交</div>
      </div>
      <div class="next" @click="go">下一题</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      submitList: [],
      record: ''
    };
  },
  mounted() {
    this.recognition = new webkitSpeechRecognition();
    this.recognition.continuous = true;
    this.recognition.interimResults = true;
    this.recognition.lang = 'cmn-Hans-CN'; // 普通话 (中国大陆)
    this.recognition.onresult = (e) => {
      // console.log(e.results.length, e.results[0].length, e);
      console.log(e.results[0][0], e.results[0][0].transcript);
      this.record = ''
      for (const key in e.results) {
        if (Object.hasOwnProperty.call(e.results, key)) {
          const element = e.results[key];
          this.record += (element[0].transcript)
        }
      }
    };
    this.recognition.onerror = function(event) {
      console.log(event);
    };
  },
  methods: {
    startRecord(e) {
      this.recognition.start();
      this.$message.info('开始录音')
      this.record = ''
    },
    submit() {
      this.record = ''
      this.recognition.stop()
      this.$message.info('录音完毕')
      this.submitList.push({})
    },
    go() {
      this.$router.push({
        name: 'educationDarwing'
      })
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  display: flex;
  .left {
    width: 45%;
    background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e9378b4f7a/606856192.png);
    background-size: 100% 100%;
    padding: 4% 2%;
    overflow-y: auto;
    img {
      width: 100%;
    }
  }
  .right {
    width: 55%;
    background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e98747c556/505248194.png);
    background-size: 100% 100%;
    padding: 0 28px;
    box-sizing: border-box;
    .headline {
      width: 100%;
      padding-top: 34px;
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      color: #2144ff;
      line-height: 25px;
      margin-bottom: 44px;
    }
    .submitList {
      display: flex;
      align-items: center;
      span {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666d73;
        line-height: 17px;
      }
      > div {
        width: 75px;
        height: 33px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #39ab8f;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 9px;
        font-weight: 400;
        color: #39ab8f;
        line-height: 9px;
        margin-right: 4px;
      }
    }
    .title {
      margin-top: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
      line-height: 22px;
    }
    .desc {
      font-size: 16px;
      font-weight: 400;
      color: #383838;
      line-height: 26px;
      margin-top: 12px;
    }
    .tip {
      padding-top: 22px;
      font-size: 16px;
      font-weight: 400;
      color: #666d73;
      line-height: 22px;
    }
    .record {
      width: 100%;
      height: 238px;
      background: #f8f8f8;
      border: 1px solid #efefef;
      padding: 24px;
      position: relative;
      margin-top: 12px;
      > div {
        font-size: 16px;
        font-weight: 400;
        color: #383838;
        line-height: 26px;
      }
      .collect {
        position: absolute;
        left: 24px;
        bottom: 24px;
        width: 127px;
        height: 33px;
        background: #4594fb;
        box-shadow: 0px 5px 6px -4px rgba(41, 54, 242, 0.31),
          inset 0px 3px 8px 0px rgba(255, 255, 255, 0.48);
        border-radius: 17px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        span {
          font-size: 12px;
          font-weight: 400;
          color: #ffffff;
          line-height: 17px;
        }
        > img {
          width: 24px;
          margin-right: 4px;
        }
      }
      .submit {
        cursor: pointer;
        position: absolute;
        right: 24px;
        bottom: 24px;
        width: 119px;
        height: 33px;
        background: #ffffff;
        box-shadow: 0px 0px 8px -4px rgba(0, 0, 0, 0.25);
        border-radius: 6px;
        border: 1px solid #d9dadc;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 400;
        color: #000000;
        line-height: 17px;
      }
    }
    .next {
      width: 269px;
      height: 44px;
      background: #f8f9ff;
      border-radius: 6px;
      border: 1px solid #4594fb;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 400;
      color: #4594fb;
      line-height: 20px;
      margin: 0 auto;
      margin-top: 37px;
      cursor: pointer;
    }
  }
}
</style>
